import { defineComponent as _defineComponent } from 'vue'
import Vue, { computed } from 'vue';
import type VueI18n from 'vue-i18n';
import { avgRGBFromBlurHash } from '@/helpers/base83-helper';
import { StreamInfo, CompetitionContent } from './types';
import PictureComp from '@/components/picture/PictureComp.vue';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderStreamsComparatorBar',
  props: {
    eventTranslation: null,
    streamInfo: null
  },
  setup(__props: any) {

const props = __props as {
	eventTranslation: (count: number) => VueI18n.TranslateResult;
	streamInfo?: StreamInfo;
};



const showMoreCompetitions = false;

const competitions = computed(() => {
	return [...Object.values(props.streamInfo?.competitions ?? {})].sort((a, b) => b.count - a.count);
});

const extraCompetitions = computed(() => {
	if (competitions.value.length > 3) return competitions.value.length - 3;
	return false;
});

function competitionStyles({ count, iconBlurHash }: CompetitionContent, total: number, index: number) {
	const [R, G, B] = iconBlurHash
		? avgRGBFromBlurHash(iconBlurHash)
		: // color gradient for cases with multiple fallbacks
		  [255, 255, 255].map(v => (v -= 22 * index));

	return {
		backgroundColor: `rgb(${R}, ${G}, ${B})`,
		flexGrow: Math.round((count / total) * 100),
	};
}

function imageUrl(url: string) {
	return Vue.filter('Thumbor')({ url, imageType: 'competitor_icon' });
}

return { __sfc: true,props, showMoreCompetitions, competitions, extraCompetitions, competitionStyles, imageUrl, PictureComp, faChevronDown }
}

})